import styled from 'styled-components';

export const TitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`

export const Subtitle = styled.div`
    color: #6c757d;
    font-size: 14px;
    margin-top: 2px;
`

export const Section = styled.div`
    margin-top: 20px;
`

export const SectionTitle = styled.div`
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #6c757d;
    margin-bottom: 8px;
`

export const InfoGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
    gap: 8px;
`

export const InfoItem = styled.div`
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    padding: 8px 10px;
`

export const InfoLabel = styled.div`
    font-size: 12px;
    color: #6c757d;
`

export const HintLabel = styled.span`
    cursor: help;
    border-bottom: 1px dotted currentColor;
`

export const InfoValue = styled.div`
    font-weight: 600;
    word-break: break-word;
`

export const ActionCard = styled.div`
    display: flex;
    gap: 10px;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    padding: 10px 12px;
    margin-bottom: 8px;
`

export const ActionIndex = styled.div`
    flex: 0 0 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #0d6efd;
    color: #fff;
    font-size: 13px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const ActionTitle = styled.div`
    font-weight: 600;
`

export const ActionDescription = styled.div`
    color: #495057;
    font-size: 14px;
`

export const EmptyText = styled.div`
    color: #6c757d;
    font-style: italic;
`

export const TechnicalToggle = styled.button`
    margin-top: 20px;
    padding: 0px;
    border: none;
    background: none;
    color: #0d6efd;
    font-size: 14px;

    &:hover {
        text-decoration: underline;
    }
`

export const Code = styled.pre`
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 8px;
    margin: 2px 0px 8px 0px;
    max-height: 200px;
    overflow: auto;
    white-space: pre-wrap;
    word-break: break-word;
    font-size: 12px;
`
